import { TrackTraceFloorMap, TrackTracePoint } from "./types";

const statusColors: Record<string, string> = {
    danger: '#dc2626',
    warning: '#f59e0b',
    success: '#16a34a',
    info: '#2563eb',
    secondary: '#6b7280',
};

export function mapPointToCanvas(point: TrackTracePoint, floorMap: TrackTraceFloorMap) {
    const x = point.x * floorMap.scale_x + floorMap.offset_x;
    const invertY = floorMap.origin === "bottom_left" || floorMap.flip_y;

    const y = invertY
        ? floorMap.image_height - (point.y * floorMap.scale_y + floorMap.offset_y)
        : point.y * floorMap.scale_y + floorMap.offset_y;

    return { x, y };
}

export function floorMapViewportToCanvas(floorMap: TrackTraceFloorMap) {
    if (!floorMap.viewport) {
        return {
            x: 0,
            y: 0,
            width: floorMap.image_width || 800,
            height: floorMap.image_height || 600,
            defaultZoom: 1,
        };
    }

    const origin = mapPointToCanvas({
        x: floorMap.viewport.origin_x,
        y: floorMap.viewport.origin_y,
    }, floorMap);
    const width = Math.max(1, floorMap.viewport.length * floorMap.scale_x);
    const height = Math.max(1, floorMap.viewport.breadth * floorMap.scale_y);
    const invertY = floorMap.origin === "bottom_left" || floorMap.flip_y;

    return {
        x: origin.x,
        y: invertY ? origin.y - height : origin.y,
        width,
        height,
        defaultZoom: Math.max(0.1, (floorMap.viewport.default_zoom_percentage || 100) / 100),
    };
}

export const markerColor = (status?: string, statusColor?: string) => {
    if (statusColor) {
        return statusColors[statusColor] || statusColor;
    }

    switch (status) {
        case 'available':
            return '#16a34a';
        case 'in_use':
            return '#2563eb';
        case 'needs_cleaning':
            return '#f97316';
        case 'maintenance':
        case 'unavailable':
            return '#dc2626';
        default:
            return '#6b7280';
    }
};

export const formatDateTime = (value?: Date | string | null) => {
    if (!value) return 'Unknown';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return 'Unknown';
    return date.toLocaleString();
};
